'use strict';

angular.module('atex.dam').controller('DamAboutController', ['$scope', '$http', function ($scope, $http) {
  $scope.versions = [];
  $scope.modules = [];

  var artifacts = [
    "structured-text",
    "copyfit",
    "module-pseries",
    "api-service-client",
    "polopoly"
  ];

  var getUIVersion = function () {
    return $http({
      method: 'GET',
      url: '/onecms/dam/ui/system/versions/'
    }).then(function (response) {
      return response.data;
    });
  };

  getUIVersion().then(function(data) {
    // Dump in the console.log all the modules.
    console.log('got data', data);
    $scope.versions = _.sortBy(data.versions, 'uiInfo.name');
    $scope.modules = _.sortBy(_.sortBy(_.filter(data.modules, function (m) {
      return artifacts.includes(m.artifactId);
    }), 'artifactId'), 'groupId');

    $scope.showSpinner = false;
  });
}]);
